import React from 'react';
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setOptionsAction} from "../../../store/reducers/commonSlice";

const tags = [
    'page_moved',
    'remove_tracing_page'
]

const LogsFilter = () => {
    const dispatch = useAppDispatch()
    const options = useAppSelector(state => state.common.options)

    const changeFilter = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const fieldName = e.target.name
        const fieldValue = e.target.value || ''
        if (!fieldName) return;

        dispatch(setOptionsAction({
            [fieldName]: fieldValue
        }))
    }

    return (
        <section className="mb-[15px]">
            <div className="container">
                <div className="text-sm w-full md:w-auto justify-between flex mb-4 justify-between">
                    <div className="flex items-center mr-5">
                        <div className="mr-4">
                            <span className="mr-3">Date From: </span>
                            <input
                                name="logsFilterDateFrom"
                                type="date"
                                className="py-1 px-4 border-[1px] outline-none rounded-sm"
                                value={options.logsFilterDateFrom}
                                onChange={changeFilter}
                            />
                        </div>
                        <div>
                            <span className="mr-3">Date To: </span>
                            <input
                                name="logsFilterDateTo"
                                type="date"
                                className="py-1 px-4 border-[1px] outline-none rounded-sm"
                                value={options.logsFilterDateTo}
                                onChange={changeFilter}
                            />
                        </div>
                    </div>

                    <div className="flex items-center">
                        <span className="mr-3">Event: </span>
                        <select
                            name="logsFilterTag"
                            className="py-1 px-4 border-[1px] outline-none rounded-sm"
                            value={options.logsFilterTag}
                            onChange={changeFilter}
                        >
                            <option value='' />
                            {tags.map((tag: string, i: number) => <option key={i} value={tag}>
                                {tag}
                            </option>)}
                        </select>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LogsFilter;